module.exports = __webpack_public_path__ + "static/media/path4.7cec0157.jpg";